import ControlCardForDelivery from '@/models/ControlCardForDelivery/ControlCardForDelivery';

export default class ControlCardForDeliveryFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.qtyCase = '';
		this.qtyLock = '';
		this.qtyOutstanding = '';
		this.transactionType = '';
		this.transactionId = '';
		this.isUsed = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			qtyCase : '0',
			qtyLock : '0',
			qtyOutstanding : '0',
			transactionType : '0',
			transactionId : '0',
			isUsed : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}